export * from './ipartnersmanager';
export * from './partnersmanager';
